import React from 'react';
import "../../Styles/yellocalfcss/pagecollect.css";

const CollectPayment = () => {
  return (
    <div className="collectpayment-page-container my-2">

      <div className="collectpayment-page-header ">
        <h2 className="collectpayment-page-title">Collect Payment</h2>
      </div>

      <div className="collectpayment-card">
        <form className="collectpayment-payment-form">
          <div className="collectpayment-form-row">
            <div className="collectpayment-form-group collectpayment-full-width">
              <label>Student Name <span className="collectpayment-required">*</span></label>
              <select>
                <option>Select Student</option>
                <option>amar</option>
                <option>akbar</option>
                <option>anthiny</option>
              </select>
            </div>
          </div>

          <div className="collectpayment-form-row">
            <div className="collectpayment-form-group collectpayment-half-width">
              <label>Paid By Parent Name</label>
              <select>
                <option>Select parent</option>
                <option>amar</option>
                <option>akbar</option>
                <option>anthiny</option>
              </select>
            </div>

            <div className="collectpayment-form-group collectpayment-half-width">
              <label>Payment Date <span className="collectpayment-required">*</span></label>
              <input type="date" />
            </div>
          </div>

          <div className="collectpayment-form-row">
            <div className="collectpayment-form-group collectpayment-half-width">
              <label>Payment Mode <span className="collectpayment-required">*</span></label>
              <select>
                <option>Select Payment Mode</option>
                <option>Google Pay</option>
                <option>Phonepe</option>
                <option>Cash</option>
              </select>
            </div>
          </div>

          <div className="collectpayment-form-footer">
            <button type="submit" className="collectpayment-submit-btn">Collect Payment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CollectPayment;
